import React, { useState } from 'react'
import { readerFile } from '@utils/pdf/download'
import { ButtonAction } from '@components/index'
import { RiDeleteBin5Fill } from 'react-icons/ri'
import { AddFile, Loader } from '@assets/icons'
import { toast } from 'react-toastify'

interface InputFileProps {
    name: string
    defaultFile: File | string | null
    isLoadingFile?: boolean
    onChange: (value: File | null) => void
    acceptFiles: string
    style?: object
    fileKeyToDelete?: (value: string) => void
    multiple?: boolean
}

export default function InputStampFile(props: InputFileProps): React.ReactElement {
    const [file, setFile] = useState<File | string | null>(null)
    const handleFile = React.useRef<HTMLInputElement | null>(null)

    const handleClick = React.useCallback(() => {
        handleFile.current?.click()
    }, [])

    const handleDelete = React.useCallback(async () => {
        if (handleFile.current) handleFile.current.value = ''
        props.onChange(null)
        setFile(null)
    }, [])

    function handleChange(e: React.ChangeEvent<HTMLInputElement>): void {
        if (e.target.files !== null) {
            const files = e.target.files
            const element = files.item(0)
            if (element) {
                const fileAccepted = props.acceptFiles.includes(element.type)
                if (!fileAccepted) {
                    toast('Formato de arquivo inválido', { type: 'error' })
                }
                props.onChange(element)
            }
            if (!props.multiple) {
                setFile(element)
            }
        }
    }
    React.useEffect(() => {
        if (props.defaultFile) setFile(props.defaultFile)
    }, [props.defaultFile])

    return (
        <>
            <input
                type='file'
                name={props.name}
                accept={props.acceptFiles}
                onChange={handleChange}
                ref={handleFile}
                style={{ display: 'none' }}
            />
            <div className={'input-file external-single-file'}
                style={props.style}>
                {file ?
                    <div className="box-single-file">
                        <img src={readerFile(file)} />
                        <div className="cover-image" style={props.style}>
                            <ButtonAction
                                title="Deletar"
                                type="button"
                                onClick={() => {
                                    handleDelete()
                                }}
                            >
                                <RiDeleteBin5Fill className="icon-button-action" />
                            </ButtonAction>
                        </div>
                    </div>
                    :
                    <button
                        className='button-input-file'
                        onClick={handleClick}
                        type='button'
                        title='Input de arquivos'
                        style={props.style}
                    >
                        {props.isLoadingFile ?
                            <Loader style={{ width: '2rem' }} />
                            :
                            <AddFile className='icon-addfile' title='Adicionar Arquivo' />
                        }
                    </button>
                }
            </div>
        </>
    )
}